export default __webpack_public_path__ + "static/media/vietnam_powerline_distribution.219a54d8.png";